export const STORE_ACHIEVEMENTS = 'achievements';
export const STORE_DUCK_HUNT = 'about-score';